export const cookiePath = "/cookie";

const displayName = "Политика обработки файлов cookie";

export default {
  path: cookiePath,
  name: "cookie",
  meta: {
    layout: "privacy-policy-and-term-of-use",
    title: displayName,
  },
  component: () => import("@/views/Cookie"),
};
